<template>
    <div class="modal-content m-selectionProducts --altEans">
        <!-- Modal Header -->
        <div class="modal-header bg-1">
            <modal-close />
            <div class="modal-title my-1">
                <h2 class="h3 mb-0" v-text="'Wybierz produkty'" />
            </div>
        </div>

        <!-- Modal Body -->
        <div class="modal-body pt-0 pb-4 px-3">
            <div
                class="row position-sticky pt-4"
                style="top: -12px; background-color: var(--color-white); z-index: 9;"
            >
                <div class="col-md-6">
                    <search-input
                        @change="
                            requestParams.name = $event
                            fetch(1)
                        "
                        class="w-100"
                        :search-input="requestParams.name"
                        :search-params-tooltip="['nazwie produktu', 'kodzie EAN']"
                    />
                </div>
            </div>

            <div
                v-if="dictProducts && dictProducts.length"
                class="m-selectionProducts__productList"
            >
                <div class="c-table table-selection-products">
                    <div class="c-thead p-0">
                        <div class="c-td is-1" v-text="'Nazwa produktu'" />
                        <div class="c-td is-2" v-text="'EAN'" />
                        <div class="c-td is-3"></div>
                    </div>
                    <div class="c-tbody" style="position: relative">
                        <page-preloader
                            mode="wrapper"
                            :style="{
                                minHeight:
                                    dictProductsStatus === 'loading'
                                        ? '3rem'
                                        : 'auto'
                            }"
                            :is-loading="dictProductsStatus === 'loading'"
                        >
                            <div
                                class="c-tr px-0"
                                v-for="product in dictProducts"
                                :key="product.id"
                                style="min-height: 3rem;"
                            >
                                <div class="c-td is-1" v-text="product.name" />
                                <div class="c-td is-2" v-text="product.ean" />
                                <div class="c-td is-3 text-right">
                                    <the-btn
                                        :class="
                                            isProductSelected(product)
                                                ? 'btn-primary'
                                                : 'btn-outline-custom'
                                        "
                                        @click.native="toggleProduct(product)"
                                    >
                                        {{
                                            isProductSelected(product)
                                                ? 'Zmień'
                                                : 'Uzupełnij'
                                        }}
                                    </the-btn>
                                </div>
                            </div>
                        </page-preloader>
                    </div>
                </div>
            </div>
            <div v-else-if="dictProductsStatus === 'loading'">
                <page-preloader
                    :min-height="'4rem'"
                    :is-loading="dictProductsStatus === 'loading'"
                />
            </div>
            <div v-else v-text="'Nie znaleziono produktów'" />
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer" style="position: sticky; bottom: 0;">
            <the-pagination
                v-if="dictProducts && dictProducts.length"
                :pagination="dictProductsPagination"
                @change="fetch"
            />
            <the-btn
                class="ml-auto"
                @click.native="$store.dispatch('toggleModal', false)"
            >
                Zamknij
            </the-btn>
        </div>
    </div>
</template>

<script>
import { wtProducts } from '@/walkthroughs/altEans'

export default {
    name: 'MerchantEanSelectionProducts',
    data() {
        return {
            dictProducts: null,
            dictProductsStatus: null,
            dictProductsPagination: null,

            requestParams: {
                name: '',
                page: 1,
                main: true,

                per: 10
            }
        }
    },

    computed: {
        isWalkthrough() {
            return this.$store.getters.getWalkthroughActive
        }
    },

    methods: {
        isProductSelected(product) {
            return product.alternative_eans?.length
        },

        async fetch(page) {
            if (this.isWalkthrough) {
                this.dictProducts = wtProducts
                this.dictProductsPagination = {
                    nextPage: 0,
                    page: 1,
                    perPage: 50,
                    prevPage: 0,
                    totalPages: 1
                }
                return
            }

            this.dictProductsStatus = 'loading'

            if (page) {
                this.requestParams.page = page
            }

            const params = { ...this.requestParams }
            for (const [key, value] of Object.entries(this.requestParams)) {
                if (value === '' || value === null || value === undefined) {
                    delete params[key]
                }
            }

            const res = await this.$store.dispatch('fetchAltEans', {
                params: {
                    ...params
                }
            })

            if (res) {
                this.dictProducts = res.data.data
                this.dictProductsPagination = res.data.pagination[0]
            }

            this.dictProductsStatus = 'idle'
        },

        toggleProduct(product) {
            this.$store.dispatch('openModal', {
                component: 'AlternativeEans',
                args: {
                    dictProduct: product,
                    selectionProductsParams: this.requestParams
                }
            })
        }
    },

    async created() {
        if (this.$store.getters.modalState.args) {
            const { params } = this.$store.getters.modalState.args

            for (const key in params) {
                if (Object.hasOwnProperty.call(params, key)) {
                    this.$set(this.requestParams, key, params[key])
                }
            }
        }

        await this.fetch()
    }
}
</script>
